import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";


const TableReport = ({ salesData, colName, data }) => {
    return (
      <Box
        sx={{
          py: "20px",
          px: { xs: "10px", sm: "50px" },
          background: "#fff",
          borderRadius: "12px",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container spacing={1}>
          <Grid
            container
            spacing={1}
            sx={{ borderBottom: "1px solid #1E1E1E", padding: "10px 0px" }}
          >
            <Grid item xs={6}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  paddingLeft: "30px",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Date
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Qty
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Amount
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            mt={2}
            sx={{
              height: "50vh",
              overflow: "auto",
              marginTop: "10px",
              paddingRight: "10px",
            }}
          >
            <Grid item xs={12}>
              {/* Data Rows */}
              {data.map((item, idx) => (
                <Grid
                  container
                  key={idx}
                  elevation={2}
                  sx={{
                    borderRadius: "10px",
                    my: "5px",
                    background: "#E3E3FF",
                  }}
                >
                  <Grid item xs={6}>
                    <Box p={1} sx={{ paddingLeft: "30px" }}>
                      <Typography
                        fontWeight={500}
                        color="#000000"
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {item?.billDate
                          ? convertDateToCustomFormat(
                              item?.billDate?.split("T")[0]
                            )
                          : convertDateToCustomFormat(
                              item?.createdDate?.split("T")[0]
                            )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box p={1}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        fontWeight={500}
                        color="#000000"
                      >
                        {item.quantity?.toFixed(1)}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    ite
                    xs={3}
                    sx={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: "10px",
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="#000000"
                      sx={{
                        // textAlign: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    />
                    <Typography
                      color="#000000"
                      sx={{
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                        paddingLeft: {sm:"10px", xs:"0px"},
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item.amount?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
};

export default TableReport;